<template>
  <div>
    <div class="text-xs-center">
      <v-btn flat small @click="toggleProductDetail" color="primary"
        >รายละเอียดสินค้า
        <i class="fa ml-1" :class="{ 'fa-angle-down': !showDetail, 'fa-angle-up': showDetail }"></i
      ></v-btn>
    </div>
    <div v-if="loading" class="text-xs-center" style="min-height: 150px">
      <v-layout justify-center align-center row style="height: 150px">
        <v-flex>
          <div class="spinner text-xs-center">
            <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
          </div>
        </v-flex>
      </v-layout>
    </div>
    <template v-if="showDetail && !loading">
      <template v-for="(product, index) in orderDetail">
        <v-layout wrap :key="'order_' + index">
          <v-flex sm1 xs2>
            <div class="ma-2">
              <v-img :src="product.imageURL" aspect-ratio="1" alt class="grey lighten-2">
                <template v-slot:placeholder>
                  <v-layout fill-height align-center justify-center ma-0>
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-layout>
                </template>
              </v-img>
            </div>
          </v-flex>
          <v-flex sm7 xs6 style="word-break: break-word;">
            <div class="ma-2">{{ product.name }} x {{ product.quantity }}</div>
          </v-flex>
          <v-flex xs4 class="text-xs-right">
            <div class="ma-2">฿{{ product.price | decimalFormat }}</div>
          </v-flex>
        </v-layout>
        <v-divider v-if="index < orderDetail.length - 1" :key="index"></v-divider>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/api'
export default {
  props: ['value'],
  data() {
    return {
      showDetail: false,
      orderDetail: [],
      loading: false
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  methods: {
    toggleProductDetail() {
      const vm = this
      vm.showDetail = !vm.showDetail

      if (vm.showDetail) {
        vm.getOrdersDeatailLineMyShop()
      }
    },
    async getOrdersDeatailLineMyShop() {
      const vm = this
      vm.loading = true
      const data = {
        pageid: vm.selectedBot.pageid,
        orderNo: this.value
      }
      let response = await api.getOrdersDeatailLineMyShop(data)
      if (response.success) {
        vm.orderDetail = response.result.orderItems
      }
      vm.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/LineMyShopOrderDetail.vue